var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.imageData.image)?_c('video',{ref:"video",staticClass:"camera-stream"}):_c('img',{staticClass:"camera-stream",attrs:{"src":_vm.imageData.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }